import stringHelpers from "./stringHelpers"

export default {
    isNumberGreaterThanZero(number) {
        return !stringHelpers.isNullOrEmpty(number) && Number(number) > 0
    },
    convertMegabytesToGigabytes(megabytes) {
        if (stringHelpers.isNullOrEmpty(String(megabytes))) {
            return null
        }
        return megabytes/1024
    }
}